import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "snies-panel" }
const _hoisted_2 = { class: "sp-cab" }
const _hoisted_3 = { class: "sp-conteo" }
const _hoisted_4 = {
  key: 0,
  class: "sp-info"
}
const _hoisted_5 = {
  key: 1,
  class: "sp-vacio"
}
const _hoisted_6 = { class: "sp-reg-cab" }
const _hoisted_7 = { class: "sp-codigo" }
const _hoisted_8 = { class: "sp-meta" }
const _hoisted_9 = { class: "sp-meta" }
const _hoisted_10 = { class: "sp-meta" }
const _hoisted_11 = {
  key: 1,
  class: "sp-bandera sp-sin-dato",
  title: "Falta la fecha de ejecutoria o la vigencia"
}
const _hoisted_12 = { class: "sp-reg-acciones" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "sp-reg-datos" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "sp-acreditado"
}
const _hoisted_19 = {
  key: 2,
  class: "sp-primer"
}
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  key: 0,
  class: "sp-resoluciones"
}
const _hoisted_22 = {
  key: 0,
  class: "sp-tabla"
}
const _hoisted_23 = {
  key: 1,
  class: "sp-nd"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "sp-vacio"
}
const _hoisted_26 = { class: "sp-nueva-res" }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = {
  key: 2,
  class: "sp-form"
}
const _hoisted_30 = { class: "sp-form-grid" }
const _hoisted_31 = ["value"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "sp-form-acciones" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "sp-error"
}

import { ref, watch, onMounted } from 'vue'
import {
  listarProgramasSniesService,
  crearProgramaSniesService,
  actualizarProgramaSniesService,
  eliminarProgramaSniesService,
  agregarResolucionService,
  eliminarResolucionService,
  getCatalogosSniesService,
  etiquetaTipoActo,
  type ProgramaSnies
} from '@/services/ProgramaSniesService'
import { useGestionCampus } from '@/store/GestionCampus'


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrosSniesPanel',
  props: {
    idPrograma: {}
  },
  setup(__props: any) {

/**
 * Registros SNIES de un programa y sus resoluciones.
 *
 * Registro calificado y acreditación de alta calidad son trámites distintos y
 * vencen por separado.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const campusStore = useGestionCampus()
const registros = ref<ProgramaSnies[]>([])
const cargando = ref(false)
const guardando = ref(false)
const expandido = ref<number | null>(null)
const editando = ref<Partial<ProgramaSnies> | null>(null)
const errorForm = ref('')

const tiposActo = ref<string[]>([])
const modalidades = ref<string[]>([])
const nivelesFormacion = ref<string[]>([])
const campus = ref<Array<{ id_campus: number; nombre: string }>>([])

const nuevaRes = ref({ tipo_acto: '', numero: '', fecha_ejecutoria: '', vigencia_anios: null as number | null })

function formatFecha(valor: string | null | undefined): string {
  if (!valor) return '—'
  const d = new Date(valor.includes('T') ? valor : valor + 'T00:00:00')
  if (isNaN(d.getTime())) return valor
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/** Texto de la bandera: lo urgente se dice con palabras, no solo con color. */
function textoBandera(r: ProgramaSnies): string {
  const res = r.resoluciones?.find(x => x.bandera === r.bandera)
  const meses = res?.meses_para_vencer
  if (meses == null) return r.bandera ?? ''
  if (meses < 0) return `vencido hace ${Math.abs(meses)} meses`
  return `vence en ${meses} meses`
}

async function cargar() {
  cargando.value = true
  try {
    registros.value = await listarProgramasSniesService({ id_programa: props.idPrograma })
  } finally {
    cargando.value = false
  }
}

function abrirNuevo() {
  errorForm.value = ''
  editando.value = {
    codigo_snies: '', id_programa: props.idPrograma, id_campus: null,
    modalidad: null, nivel_formacion: null, titulo_otorgado: '', estado: 'Activo'
  }
}

function abrirEditar(r: ProgramaSnies) {
  errorForm.value = ''
  editando.value = { ...r }
}

async function guardar() {
  if (!editando.value?.codigo_snies) return
  guardando.value = true
  errorForm.value = ''
  try {
    const payload = { ...editando.value, id_programa: props.idPrograma }
    const resultado = editando.value.id_programa_snies
      ? await actualizarProgramaSniesService(editando.value.id_programa_snies, payload)
      : await crearProgramaSniesService(payload)

    if (!resultado.ok) {
      errorForm.value = resultado.error ?? 'No se pudo guardar'
      return
    }
    editando.value = null
    await cargar()
  } finally {
    guardando.value = false
  }
}

async function eliminar(r: ProgramaSnies) {
  const resultado = await eliminarProgramaSniesService(r.id_programa_snies)
  // El backend bloquea si hay autoevaluaciones sobre el registro; su mensaje
  // explica cuántas, así que se muestra tal cual.
  if (!resultado.ok) {
    errorForm.value = resultado.error ?? 'No se pudo eliminar'
    return
  }
  await cargar()
}

async function agregarResolucion(r: ProgramaSnies) {
  const resultado = await agregarResolucionService(r.id_programa_snies, {
    tipo_acto: nuevaRes.value.tipo_acto,
    numero: nuevaRes.value.numero || null,
    fecha_ejecutoria: nuevaRes.value.fecha_ejecutoria || null,
    vigencia_anios: nuevaRes.value.vigencia_anios
  })
  if (!resultado.ok) {
    errorForm.value = resultado.error ?? 'No se pudo agregar la resolución'
    return
  }
  nuevaRes.value = { tipo_acto: '', numero: '', fecha_ejecutoria: '', vigencia_anios: null }
  await cargar()
}

async function quitarResolucion(id: number) {
  if (await eliminarResolucionService(id)) await cargar()
}

watch(() => props.idPrograma, () => { expandido.value = null; editando.value = null; cargar() })

onMounted(async () => {
  await cargar()
  const catalogos = await getCatalogosSniesService()
  tiposActo.value = catalogos.tipos_acto
  modalidades.value = catalogos.modalidades
  nivelesFormacion.value = catalogos.niveles_formacion
  await campusStore.cargarTodos()
  campus.value = campusStore.campus as any[]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h4", null, "Registro ante el Ministerio (SNIES)", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(registros.value.length) + " registro" + _toDisplayString(registros.value.length === 1 ? '' : 's'), 1),
      _createElementVNode("button", {
        class: "btn-sp-nuevo",
        onClick: abrirNuevo
      }, "+ Registro")
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("p", { class: "sp-ayuda" }, " El ministerio registra por programa, municipio y modalidad, así que un mismo programa puede tener varios registros con vencimientos distintos. ", -1)),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Cargando registros…"))
      : (!registros.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Este programa no tiene registros SNIES cargados. "))
        : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registros.value, (r) => {
      return (_openBlock(), _createElementBlock("div", {
        key: r.id_programa_snies,
        class: "sp-registro"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(r.codigo_snies), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(r.campus?.nombre ?? r.municipio ?? '—'), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(r.modalidad ?? '—'), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(r.nivel_formacion ?? '—'), 1),
          (r.bandera)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(['sp-bandera', `sp-${r.bandera}`])
              }, _toDisplayString(textoBandera(r)), 3))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, " sin fecha ")),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn-sp",
              onClick: ($event: any) => (expandido.value = expandido.value === r.id_programa_snies ? null : r.id_programa_snies)
            }, _toDisplayString(expandido.value === r.id_programa_snies ? 'Ocultar' : 'Resoluciones'), 9, _hoisted_13),
            _createElementVNode("button", {
              class: "btn-sp",
              onClick: ($event: any) => (abrirEditar(r))
            }, "Editar", 8, _hoisted_14),
            _createElementVNode("button", {
              class: "btn-sp btn-sp-peligro",
              onClick: ($event: any) => (eliminar(r))
            }, "Eliminar", 8, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (r.vence_registro)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                _cache[12] || (_cache[12] = _createTextVNode("Registro calificado vence ")),
                _createElementVNode("strong", null, _toDisplayString(formatFecha(r.vence_registro)), 1)
              ]))
            : _createCommentVNode("", true),
          (r.alta_calidad_vigente)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Acreditado en alta calidad"))
            : _createCommentVNode("", true),
          (r.en_primer_registro)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "En primer registro"))
            : _createCommentVNode("", true),
          (r.anios_funcionamiento !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(r.anios_funcionamiento) + " años en el SNIES", 1))
            : _createCommentVNode("", true)
        ]),
        (expandido.value === r.id_programa_snies)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (r.resoluciones?.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                    _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Acto"),
                        _createElementVNode("th", null, "Número"),
                        _createElementVNode("th", null, "Ejecutoria"),
                        _createElementVNode("th", null, "Vigencia"),
                        _createElementVNode("th", null, "Vence"),
                        _createElementVNode("th")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.resoluciones, (res) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: res.id_resolucion
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_unref(etiquetaTipoActo)(res.tipo_acto)), 1),
                          _createElementVNode("td", null, _toDisplayString(res.numero ?? '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(formatFecha(res.fecha_ejecutoria)), 1),
                          _createElementVNode("td", null, _toDisplayString(res.vigencia_anios ? res.vigencia_anios + ' años' : '—'), 1),
                          _createElementVNode("td", null, [
                            (res.fecha_vencimiento)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(['sp-vence', res.bandera ? `sp-${res.bandera}` : ''])
                                }, _toDisplayString(formatFecha(res.fecha_vencimiento)), 3))
                              : (_openBlock(), _createElementBlock("span", _hoisted_23, "no calculable"))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn-quitar-sp",
                              onClick: ($event: any) => (quitarResolucion(res.id_resolucion))
                            }, "×", 8, _hoisted_24)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_25, "Sin resoluciones registradas.")),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nuevaRes.value.tipo_acto) = $event)),
                  class: "sp-input"
                }, [
                  _cache[14] || (_cache[14] = _createElementVNode("option", {
                    value: "",
                    disabled: ""
                  }, "Tipo de acto…", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposActo.value, (t) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: t,
                      value: t
                    }, _toDisplayString(_unref(etiquetaTipoActo)(t)), 9, _hoisted_27))
                  }), 128))
                ], 512), [
                  [_vModelSelect, nuevaRes.value.tipo_acto]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nuevaRes.value.numero) = $event)),
                  class: "sp-input sp-corto",
                  placeholder: "Número"
                }, null, 512), [
                  [_vModelText, nuevaRes.value.numero]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nuevaRes.value.fecha_ejecutoria) = $event)),
                  type: "date",
                  class: "sp-input",
                  title: "Fecha de ejecutoria"
                }, null, 512), [
                  [_vModelText, nuevaRes.value.fecha_ejecutoria]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nuevaRes.value.vigencia_anios) = $event)),
                  type: "number",
                  min: "1",
                  max: "20",
                  class: "sp-input sp-corto",
                  placeholder: "Años"
                }, null, 512), [
                  [
                    _vModelText,
                    nuevaRes.value.vigencia_anios,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("button", {
                  class: "btn-sp btn-sp-ok",
                  disabled: !nuevaRes.value.tipo_acto,
                  onClick: ($event: any) => (agregarResolucion(r))
                }, " Agregar ", 8, _hoisted_28)
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "sp-ayuda-res" }, " El vencimiento no se escribe: se calcula como ejecutoria + vigencia. ", -1))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (editando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("h5", null, _toDisplayString(editando.value.id_programa_snies ? 'Editar registro' : 'Nuevo registro SNIES'), 1),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("label", null, [
              _cache[16] || (_cache[16] = _createTextVNode("Código SNIES *")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editando.value.codigo_snies) = $event)),
                class: "sp-input"
              }, null, 512), [
                [_vModelText, editando.value.codigo_snies]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[18] || (_cache[18] = _createTextVNode("Campus ")),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editando.value.id_campus) = $event)),
                class: "sp-input"
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, "— Sin campus —", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campus.value, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.id_campus,
                    value: c.id_campus
                  }, _toDisplayString(c.nombre), 9, _hoisted_31))
                }), 128))
              ], 512), [
                [_vModelSelect, editando.value.id_campus]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[20] || (_cache[20] = _createTextVNode("Modalidad ")),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editando.value.modalidad) = $event)),
                class: "sp-input"
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("option", { value: null }, "—", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalidades.value, (m) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: m,
                    value: m
                  }, _toDisplayString(m), 9, _hoisted_32))
                }), 128))
              ], 512), [
                [_vModelSelect, editando.value.modalidad]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[22] || (_cache[22] = _createTextVNode("Nivel de formación ")),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editando.value.nivel_formacion) = $event)),
                class: "sp-input"
              }, [
                _cache[21] || (_cache[21] = _createElementVNode("option", { value: null }, "—", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nivelesFormacion.value, (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_33))
                }), 128))
              ], 512), [
                [_vModelSelect, editando.value.nivel_formacion]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[23] || (_cache[23] = _createTextVNode("Título otorgado")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editando.value.titulo_otorgado) = $event)),
                class: "sp-input"
              }, null, 512), [
                [_vModelText, editando.value.titulo_otorgado]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[25] || (_cache[25] = _createTextVNode("Estado ")),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editando.value.estado) = $event)),
                class: "sp-input"
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("option", { value: "Activo" }, "Activo", -1),
                _createElementVNode("option", { value: "Inactivo" }, "Inactivo", -1)
              ]), 512), [
                [_vModelSelect, editando.value.estado]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: "btn-sp",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (editando.value = null))
            }, "Cancelar"),
            _createElementVNode("button", {
              class: "btn-sp btn-sp-ok",
              disabled: !editando.value.codigo_snies || guardando.value,
              onClick: guardar
            }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_35)
          ]),
          (errorForm.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(errorForm.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})